import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Image, Row, Col, message, Progress } from 'antd';
import { saveBase64Png, base64SToURL, isMobile, isSafari } from 'utils/utils';
import { get } from 'api/api';
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import { Button } from 'ui-kit';
import './SignageItem.scss';

const errorMessage = {
  dowload: 'Something went wrong while trying to download the signage! Please try again later.',
  print: 'Something went wrong while trying to print the signage! Please try again later.',
  sendImage: 'Something went wrong while trying to send email the signage! Please try again later.',
};

const SignageItem = (props) => {
  const [downloadProgress, setDownloadProgress] = useState(false);
  const fetchSignage = () => {
    const url = `/services/store/${props.storeId}/signage/${props.imageId}/`;
    const promise = get(url, {});
    return promise;
  };
  const fetchSignageOperation = async (operationFunc, errMsg) => {
    setDownloadProgress(true);
    const result = await fetchSignage();
    try {
      operationFunc(result);
    } catch (error) {
      message.error(errMsg);
    }
    setDownloadProgress(false);
  };
  // Download image
  const downloadImage = () => {
    fetchSignageOperation((res) => {
      const fileName = `Signage${props.index + 1}.png`;
      saveBase64Png({ base64String: res.data.signage, fileName });
    }, errorMessage.download);
  };
  // Print Image
  const printImage = () => {
    fetchSignageOperation((res) => {
      const url = base64SToURL(res.data.signage, 'image/png');
      const windowRef = window.open(url);
      windowRef.onload = () => {
        windowRef.focus();
        windowRef.print();
      };
    }, errorMessage.print);
  };

  return (
    <Col xs={24} md={12} lg={8} className="SignageItem">
      <Row>
        <Row gutter={[0, 8]} className="SignageItem_Header">
          <Col xs={24}>
            <h5>{props.title}</h5>
          </Col>
          <Col xs={24}>
            <Image src={props.src} />
          </Col>
        </Row>
        <Row className="SignageItem_Footer">
          <Button
            startIcon={<DownloadOutlined />}
            variant="text"
            size="small"
            onClick={downloadImage}
          >
            Download
          </Button>

          {(!isSafari || !isMobile) && (
            <Button
              startIcon={<PrinterOutlined />}
              variant="text"
              size="small"
              onClick={printImage}
            >
              Print
            </Button>
          )}
        </Row>
      </Row>
      {downloadProgress && (
        <Progress
          strokeColor={{
            from: '#108ee9',
            to: '#87d068',
          }}
          percent={100}
          showInfo={false}
          status="active"
        />
      )}
    </Col>
  );
};

SignageItem.propTypes = {
  index: PropTypes.number,
  src: PropTypes.string,
  imageId: PropTypes.string,
  storeId: PropTypes.number,
  title: PropTypes.string,
};

export default SignageItem;
